<template>
    <div>
        <div class="content">
            <div style="display: flex;justify-content: space-between">
                <el-button size="small" type="primary" @click="addBtn">新增</el-button>
                <Input search enter-button placeholder="请输入名称" style="width: 250px" v-model="searchContent"
                       @on-search='searchBtn'/>
            </div>
            <div class="tableBox">
                <el-table
                        :data="tableData"
                        border
                        :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
                        style="width: 100%">
                    <el-table-column prop="number" label="编号"/>
                    <el-table-column prop="riskName" label="名称"/>
                    <el-table-column prop="areaName" label="所属区域"/>
                    <el-table-column prop="depName" label="所属部门"/>
                    <el-table-column prop="riskType" label="风险类型">
                        <template slot-scope="{ row }">
                            {{ riskTypeArr[row.riskType] }}
                        </template>
                    </el-table-column>
<!--                    <el-table-column prop="analyticalMethod" label="评估结果" width="175">
                        <template slot-scope="{ row }">
                            <div v-if="row.riskType !== 0" class="tagBox">
                                <div v-for="item in row.analyticalMethod.split(',')" :key="item">
                                    {{ analyticalMethodArr[item - 1] }}：
                                    &lt;!&ndash; ls &ndash;&gt;
                                    <span v-if="item === '1' || item === 0'4'">
                    <el-tag v-if="row.riskMatrix === null || row.riskMatrix === undefined" size="small"
                            type="info">未评估</el-tag>
                    <el-tag v-if="row.riskMatrix === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
                    <el-tag v-if="row.riskMatrix === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
                    <el-tag v-if="row.riskMatrix === 2" style="color: #666666;background: yellow;borderColor: yellow"
                            size="small" effect="dark">一般风险</el-tag>
                    <el-tag v-if="row.riskMatrix === 3" size="small" effect="dark">低风险</el-tag>
                  </span>
                                    &lt;!&ndash; lec &ndash;&gt;
                                    <span v-if="item === '2' || item === '5'">
                    <el-tag v-if="row.riskAnalysis === null || row.riskAnalysis === undefined" size="small" type="info">未评估</el-tag>
                    <el-tag v-if="row.riskAnalysis === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
                    <el-tag v-if="row.riskAnalysis === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
                    <el-tag v-if="row.riskAnalysis === 2" style="color: #666666;background: yellow;borderColor: yellow"
                            size="small" effect="dark">一般风险</el-tag>
                    <el-tag v-if="row.riskAnalysis === 3" size="small" effect="dark">低风险</el-tag>
                  </span>
                                    &lt;!&ndash; mes &ndash;&gt;
                                    <span v-if="item === '3' || item === '6'">
                    <el-tag v-if="row.degreeAnalysis === null || row.degreeAnalysis === undefined" size="small"
                            type="info">未评估</el-tag>
                    <el-tag v-if="row.degreeAnalysis === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
                    <el-tag v-if="row.degreeAnalysis === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
                    <el-tag v-if="row.degreeAnalysis === 2"
                            style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
                    <el-tag v-if="row.degreeAnalysis === 3" size="small" effect="dark">低风险</el-tag>
                  </span>
                                </div>
                            </div>
                            <div v-else class="tagBox">LS：
                                <el-tag v-if="row.riskMatrix === null || row.riskMatrix === undefined" size="small"
                                        type="info">未评估
                                </el-tag>
                                <el-tag v-if="row.riskMatrix === 0" type="danger" effect="dark" size="small">重大风险
                                </el-tag>
                                <el-tag v-if="row.riskMatrix === 1" type="warning" effect="dark" size="small">较大风险
                                </el-tag>
                                <el-tag v-if="row.riskMatrix === 2"
                                        style="color: #666666;background: yellow;borderColor: yellow" effect="dark"
                                        size="small">一般风险
                                </el-tag>
                                <el-tag v-if="row.riskMatrix === 3" size="small" effect="dark">低风险</el-tag>
                            </div>
                        </template>
                    </el-table-column>-->
<!--                    <el-table-column label="评估风险等级">
                        <template slot-scope="{ row }">
                            <el-tag v-if="row.result === 0" effect="dark" type="danger" size="small">重大风险</el-tag>
                            <el-tag v-if="row.result === 1" effect="dark" type="warning" size="small">较大风险</el-tag>
                            <el-tag v-if="row.result === 2" effect="dark"
                                    style="color: #666666;background: yellow;borderColor: yellow" size="small">一般风险
                            </el-tag>
                            <el-tag v-if="row.result === 3" effect="dark" size="small">低风险</el-tag>
                        </template>
                    </el-table-column>-->
                    <el-table-column label="风险等级">
                      <template slot-scope="{ row }">
                        <el-tag v-if="row.color === '重大风险'" effect="dark"
                                style="color: #ffffff;background: #ff0000;borderColor: #ff0000" type="danger" size="small">重大风险</el-tag>
                        <el-tag v-if="row.color === '较大风险'" effect="dark"
                                style="color: #ffffff;background: #ff6200;borderColor: #ff6200" type="warning" size="small">较大风险</el-tag>
                        <el-tag v-if="row.color === '一般风险'" effect="dark"
                                style="color: #666666;background: yellow;borderColor: yellow" size="small">一般风险
                        </el-tag>
                        <el-tag v-if="row.color === '低风险'" effect="dark"
                                style="color: #ffffff;background: #00b2ff;borderColor: #00b2ff" size="small">低风险</el-tag>
                      </template>
                    </el-table-column>
<!--                    <el-table-column label="管控等级">
                        <template slot-scope="{ row }">
                            <el-tag v-if="row.controlLevel === 0 && row.riskType !== 0" effect="dark" type="danger"
                                    size="small">重大风险
                            </el-tag>
                            <el-tag v-else-if="row.controlLevel === 1 && row.riskType !== 0" effect="dark"
                                    type="warning" size="small">较大风险
                            </el-tag>
                            <el-tag v-else-if="row.controlLevel === 2 && row.riskType !== 0" effect="dark"
                                    style="color: #666666;background: yellow;borderColor: yellow" size="small">一般风险
                            </el-tag>
                            <el-tag v-else-if="row.controlLevel === 3 && row.riskType !== 0" effect="dark" size="small">
                                低风险
                            </el-tag>
                            <span v-else>无</span>
                        </template>
                    </el-table-column>-->
<!--                    <el-table-column prop="" label="管控层级">
                        <template slot-scope="{ row }">
                            {{ controlHierarchyList[row.controlHierarchy] }}
                        </template>
                    </el-table-column>-->
                    <el-table-column prop="evaluatorEmpName" label="评估人员"/>
                    <el-table-column prop="evaluationTime" label="评估日期">
                        <template slot-scope="{ row }">
                            <span v-if="row.evaluationTime">{{ row.evaluationTime | timeFilter }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nextEvaluationTime" label="复评日期">
                        <template slot-scope="{ row }">
                            <span v-if="row.nextEvaluationTime">{{ row.nextEvaluationTime | timeFilter }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nextEvaluationTime" label="二维码" width="102">
                        <template slot-scope="{ row }">
                            <span :id="'qrCodeDiv'+row.id" @click="openQRCodeModal(row)"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="{ row }">
                            <el-link v-if="row.status === 0" :underline="false" style="color: red; padding: 0 2px"
                                     @click="editBtn(row)">编辑
                            </el-link>
                            <el-link v-if="row.riskType !== 0 && row.identifyUserId === userId" :underline="false"
                                     style="color: #E6A23C; padding: 0 2px"
                                     @click="identificationBtn(row.id)">辨识
                            </el-link>
                            <el-link v-if="(row.status || row.riskType === 0) > 0 && row.evaluatorUserId === userId"
                                     :underline="false" style="color: #67C23A; padding: 0 2px"
                                     @click="assessmentBtn(row)">评估
                            </el-link>
                            <el-link v-if="(row.riskType !== 0 && row.status === 2) && row.controllerUserId === userId"
                                     :underline="false" style="color: #F56C6C; padding: 0 2px"
                                     @click="controlBtn(row)">管控
                            </el-link>
                            <el-link :underline="false" style="color: #909399; padding: 0 2px" @click="detailBtn(row)">
                                详情
                            </el-link>
                            <el-link :underline="false" style="color: red; padding: 0 2px" @click="deleteBtn(row)">
                                删除
                            </el-link>
                            <el-link :underline="false" style="color: #1b61f1; padding: 0 2px"
                                     @click="openSelectRiskFactorWin(row)">危险因素
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 15px; text-align: right">
                    <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange'/>
                </div>
            </div>
        </div>
        <div v-if="showStatus">
            <riskPointDia :showStatus="showStatus" :riskPointId="riskPointId" :assessmentObj="assessmentObj"
                          @backStatus="backStatus"/>
        </div>

        <Modal :title="qrCodeModalTile" v-model="showQRCodeModal">
            <div id="qrCode" style="margin-left: 10%;"></div>
        </Modal>

        <!-- 选择危险因素 列表 -->
        <Modal :closable="false" v-model="showSelectRiskFactorModal" title="风险点危险因素" width="80%" height="80%">
            <div>
                <el-button size="small" type="primary" @click="showRiskFactorDialog=true">新增</el-button>
                <el-table :data="riskFactorRecord" border style="width: 100%">
                    <el-table-column align="center" width="55" label="选择">
                        <template slot-scope="scope">
                            <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                            <el-radio class="radio" v-model="editRiskRow.riskFactorId" :label="scope.row.id">&nbsp;
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="factorName" label="名称"></el-table-column>
                    <el-table-column prop="hazardFactor" label="危害因素"></el-table-column>
                    <el-table-column prop="securityArrangement" label="安全措施"></el-table-column>
                    <el-table-column prop="emergencyMeasure" label="应急措施"></el-table-column>
                    <el-table-column prop="checkStandard" label="排查标准"></el-table-column>
                    <el-table-column prop="engineeringMeasure" label="工程措施"></el-table-column>
                    <el-table-column prop="managementMeasure" label="管理措施"></el-table-column>
                    <el-table-column prop="individualProtection" label="个体防护"></el-table-column>
                    <el-table-column prop="educationalTraining" label="教育培训"></el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="{ row }">
                            <el-link :underline="false" style="color: #086ff5; padding: 0 2px"
                                     @click="editFactorBtn(row)">编辑
                            </el-link>
                            <el-link :underline="false" style="color: red; padding: 0 2px"
                                     @click="deleteFactorBtn(row)">删除
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <Button type="text" @click="showSelectRiskFactorModal=false">取消</Button>
                <Button type="primary" @click="saveSelectRiskFactorBtn">确定</Button>
            </div>
        </Modal>

        <el-dialog :visible.sync="showRiskFactorDialog" :rules="riskfactorRules"
                   :title="riskFactForm=={} ? '添加危险因素':'修改危险因素'" width="60%">
            <el-form :model="riskFactForm" ref="riskFactForm">
                <el-form-item label="危险因素名称">
                    <el-input v-model="riskFactForm.factorName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-col :span="12">
                        <el-form-item label="危害因素">
                            <el-input type="textarea" :rows="2" placeholder="请输入危害因素内容"
                                      v-model="riskFactForm.hazardFactor"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="安全措施">
                            <el-input type="textarea" :rows="2" placeholder="请输入安全措施内容"
                                      v-model="riskFactForm.securityArrangement"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-col :span="12">
                        <el-form-item label="应急措施">
                            <el-input type="textarea" :rows="2" placeholder="请输入应急措施内容"
                                      v-model="riskFactForm.emergencyMeasure"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排查标准">
                            <el-input type="textarea" :rows="2" placeholder="请输入排查标准内容"
                                      v-model="riskFactForm.checkStandard"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-col :span="12">
                        <el-form-item label="工程措施">
                            <el-input type="textarea" :rows="2" placeholder="请输入工程措施内容"
                                      v-model="riskFactForm.engineeringMeasure"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="管理措施">
                            <el-input type="textarea" :rows="2" placeholder="请输入管理措施内容"
                                      v-model="riskFactForm.managementMeasure"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-col :span="12">
                        <el-form-item label="个体防护">
                            <el-input type="textarea" :rows="2" placeholder="请输入个体防护内容"
                                      v-model="riskFactForm.individualProtection"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="教育培训">
                            <el-input type="textarea" :rows="2" placeholder="请输入教育培训内容"
                                      v-model="riskFactForm.educationalTraining"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="showRiskFactorDialog = false">取 消</el-button>
            <el-button type="primary" @click="submitRiskFactorForm()">确 定</el-button>
          </span>
        </el-dialog>

        <Modal :title="riskPoint==null ? '添加风险点':'修改风险点'" width="60%" v-model="showAddRiskPointModal"
               @on-cancel="closeAddRiskPointModal">
            <AddRiskPoint ref="addRiskPoint" :riskPoint="riskPoint" :callBack="closeAddRiskPointModal"></AddRiskPoint>
            <div slot="footer">
            </div>
        </Modal>
    </div>
</template>

<script>
    import {
        getRiskPointList,
        riskPointDelete,
        riskPointAssessment,
        getRiskFactorList,
        riskFactorAdd,
        riskFactorUpdate,
        riskFactorDelete, riskPointupdateRiskFactorId
    } from "@/api/processManager";
    import riskPointDia from "./riskPointDia/index"
    import AddRiskPoint from "./comps/AddRiskPoint"
    import QRCode from "qrcodejs2";

    export default {
        name: 'ProcessRiskPoint',
        components: {
            riskPointDia,
            AddRiskPoint
        },
        data() {
            return {
                userId: '',
                tableData: [],
                total: 0,
                limit: 10,
                curPage: 1,
                searchContent: '',
                // 风险类型的数组
                riskTypeArr: ['固有风险', '作业风险', '设备风险'],
                // 分析方法
                analyticalMethodArr: ['JHA_LS', 'JHA_LEC', 'JHA_MES', 'SCL_LS', 'SCL_LEC', 'SCL_MES'],
                // 风险评估的弹窗状态
                showStatus: false,
                showAddRiskPointModal: false,
                riskPoint: null,
                // 传过去的需要评价的对象（这里本来应该把id传过去，子组件请求，但是渲染的时候会闪一下。就用了这个办法）
                assessmentObj: {},
                // 管控层级的数组
                controlHierarchyList: ['公司级', '车间级', '班组级', '岗位级'],
                editRiskRow: {},
                showSelectRiskFactorModal: false,
                showRiskFactorDialog: false,
                showQRCodeModal: false,
                qrCodeModalTile: "风险点二维码",
                riskFactorRecord: [],
                riskFactForm: {},
                riskfactorRules: {
                    factorName: [{required: true, message: '请输入', trigger: 'blur'}],
                    hazardFactor: [{required: true, message: '请选择', trigger: 'blur'}],
                    securityArrangement: [{required: true, message: '请选择', trigger: 'blur'}],
                    emergencyMeasure: [{required: true, message: '请输入', trigger: 'blur'}],
                    checkStandard: [{required: true, message: '请选择', trigger: 'blur'}],
                    engineeringMeasure: [{required: true, message: '请选择', trigger: 'blur'}],
                    managementMeasure: [{required: true, message: '请选择', trigger: 'blur'}],
                    individualProtection: [{required: true, message: '请选择', trigger: 'blur'}],
                    educationalTraining: [{required: true, message: '请选择', trigger: 'blur'}]
                },
            }
        },
        mounted() {
            this.userId = Number(localStorage.getItem('userId'))
            this.getData();
        },
        methods: {
            /**
             * 关闭添加风险点弹框
             */
            closeAddRiskPointModal() {
                this.$refs['addRiskPoint'].$refs['ruleForm'].resetFields();
                this.showAddRiskPointModal = false;
                this.getData();
            },
            // 获取表格数据
            getData() {
                getRiskPointList({limit: this.limit, curPage: this.curPage, search: this.searchContent}).then(res => {
                    this.tableData = res.body.data;
                    console.log("列表")
                    console.log(this.tableData)
                    this.total = res.body.cum;
                    this.$nextTick(() => {
                        this.tableData.map((item) => {
                            this.createQRCode(item.id);
                        })
                    })

                })
            },
            // 新增按钮
            addBtn() {
                //this.$router.push('AddRiskPoint');
                this.riskPoint = null;
                this.showAddRiskPointModal = true;
            },
            // 编辑按钮
            editBtn(row) {
                this.riskPoint = row;
                this.showAddRiskPointModal = true;
                // this.$router.push({
                //   path: 'AddRiskPoint',
                //   query: { id: id }
                // })
            },
            // 辨识按钮
            identificationBtn(id) {
                this.$router.push({
                    path: 'AddriskPointIdentification',
                    query: {id: id}
                })
            },
            // 管控按钮
            controlBtn(row) {
                this.$router.push({
                    path: 'AddRiskPointControl',
                    query: {id: row.id, depId: row.depId, status: row.analyticalMethodClassify}
                })
            },
            // 评估按钮
            assessmentBtn(row) {
                riskPointAssessment(row.id).then(res => {
                    this.assessmentObj = res.body.data;
                    this.showStatus = true;
                    this.riskPointId = row.id;
                })
            },
            // 弹窗组件回传的数据的事件
            backStatus(row) {
                this.showStatus = row.status;
                if (row.refresh) {
                    this.getData();
                }
            },
            // 删除按钮
            deleteBtn(row) {
                this.$confirm(`删除风险点 "${row.riskName}", 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    riskPointDelete(row.id).then(res => {
                        this.$message.success('删除成功');
                        this.getData()
                    })
                }).catch(() => {
                    return
                });
            },
            // 详情按钮
            detailBtn(row) {
                this.$router.push({
                    path: 'riskPointDetail',
                    query: {id: row.id}
                })
            },
            // 搜索框
            searchBtn() {
                this.getData();
            },
            // 翻页的事件
            curPageChange(val) {
                this.curPage = val;
                this.getData();
            },
            /**
             * 创建二维码
             * @param id
             */
            createQRCode: function (id) {
                document.getElementById("qrCodeDiv" + id).innerHTML = "";
                new QRCode(document.getElementById("qrCodeDiv" + id), {
                    text: "id=" + id,
                    width: 80,
                    height: 80,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },

            /**
             * 打开风险点二维码
             */
            openQRCodeModal(row) {
                this.showQRCodeModal = true;
                this.qrCodeModalTile = "【" + row.riskName + "】风险点二维码";
                this.$nextTick(() => {
                  document.getElementById("qrCode").innerHTML = "";
                  new QRCode(document.getElementById("qrCode"), {
                    text:  "id=" + row.id,
                    width: 400,
                    height: 400,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.H //容错率，L/M/H
                  });
                })
            },
            /**
             * 打开配置危险因素
             * @param row
             */
            openSelectRiskFactorWin(row) {
                this.showSelectRiskFactorModal = true;
                this.editRiskRow = row;
                this.getRiskFactorData();
            },

            /**
             * 保存设置危险因素
             */
            saveSelectRiskFactorBtn() {
                riskPointupdateRiskFactorId(this.editRiskRow).then(res => {
                    this.$message.success('保存成功');
                    this.getData();
                    this.showSelectRiskFactorModal = false;
                })
            },

            /**
             * 保存危险因素
             */
            submitRiskFactorForm() {
                this.$refs['riskFactForm'].validate((valid) => {
                    if (valid) {
                        let obj = {...this.riskFactForm}
                        // 编辑
                        if (obj.id) {
                            riskFactorUpdate(obj).then(res => {
                                this.$message.success('保存成功');
                                this.getRiskFactorData();
                                this.showRiskFactorDialog = false;
                            })
                        } else {
                            // 新增
                            riskFactorAdd(obj).then(res => {
                                this.$message.success('保存成功');
                                this.getRiskFactorData();
                                this.showRiskFactorDialog = false;
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },

            /**
             * 获取危险因素列表
             */
            getRiskFactorData() {
                getRiskFactorList({}).then(res => {
                    this.riskFactorRecord = res.body.data;
                })
            },

            // 编辑按钮
            editFactorBtn(row) {
                this.showRiskFactorDialog = true;
                this.riskFactForm = row;
            },

            /**
             * 删除危险因素
             * @param row
             */
            deleteFactorBtn(row) {
                this.$confirm(`删除风险点 "${row.factorName}", 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    riskFactorDelete(row.id).then(res => {
                        this.$message.success('删除成功');
                        this.getRiskFactorData()
                    })
                }).catch(() => {
                    return
                });
            }
        }
    }
</script>

<style scoped>
    .tableBox {
        margin-top: 10px
    }

    .tagBox span {
        margin-bottom: 2px
    }

    .el-form-item {
        margin-bottom: 0px;
    }

    .el-col-12 /deep/ {
        padding: 10px 10px;
    }
</style>
